import React from 'react';
import { motion } from 'motion/react';
import ParticleBackground from '../common/ParticleBackground';
import './CategorySelection.css';

export default function CategorySelection({ onSelect }) {
  const categories = [
    {
      id: 'cards',
      title: 'The Cheetu Club',
      subtitle: 'Classic Card Games (28, 56, Poker)',
      icon: '/assets/resources/The-Cheetu-Club.svg',
      active: true,
    },
    {
      id: 'boards',
      title: 'The Board Room',
      subtitle: 'Board Games (Ludo)',
      icon: '/assets/resources/The-Board-Game-Club.svg',
      active: true,
    },
  ];

  return (
    <div className="category-selection">
      <ParticleBackground />
      <motion.div 
        className="category-header"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <h1>Welcome to The Game Vault</h1>
        <p>What would you like to play?</p>
      </motion.div>

      <div className="category-grid">
        {categories.map((cat) => (
          <motion.button
            key={cat.id}
            className={`category-tile ${!cat.active ? 'disabled' : ''}`}
            whileHover={cat.active ? { scale: 1.05, translateY: -5 } : {}}
            whileTap={cat.active ? { scale: 0.95 } : {}}
            onClick={() => cat.active && onSelect(cat.id)}
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
          >
            <div className="cat-icon">
              <img src={cat.icon} alt={cat.title} className={`cat-logo-img logo-${cat.id}`} />
            </div>
            <div className="cat-info">
              <h2>{cat.title}</h2>
              <p>{cat.subtitle}</p>
            </div>
            {!cat.active && <div className="coming-soon-badge">Coming Soon</div>}
          </motion.button>
        ))}
      </div>
    </div>
  );
}
